<template>
	<SOSlotModal
		:modal-title="'Ubah Tanggal Lahir'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<SOInputDate
				:title="'Tanggal Lahir'"
				:placeholder="'Tanggal Lahir'"
				:value="(customer.tanggal_lahir <= 0) ? null : $moment.unix(customer.tanggal_lahir / 1000).format('YYYY-MM-DD')"
				:max-date="$moment().format('YYYY-MM-DD')"
				:id="'tanggal-lahir'"
				@get-date="getTanggalLahir"
			/>
			<div class="f-regular f-12 f-c-midgrey m-t-4">
				Untuk target promo: saat konsumen berulang tahun
			</div>
			<ErrorMessage
				class="error"
				label="Tanggal Lahir"
				:validation="$v.customerTemp.tanggal_lahir"
			/>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Simpan'"
				:primary="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled"
				:loading="pageSetting.btn.save.loading"
				@action="update"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators"

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputDate from "@/so-components/global/input/SOInputDate";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";

export default {
	name: "CustomerModalUbahTanggalLahir",
	components: {
		SOSlotModal,
		SOInputDate,
		SOButton,
		ErrorMessage
	},
	computed: {
		...mapGetters("customerModule", {
			customer: "getDetailCustomer",
		}),
	},
	data() {
		return {
			id: "modal-customer",
			customerTemp: {},
			pageSetting: {
				btn: {
					save: {
						disabled: false,
						loading: false,
					}
				}
			}
		}
	},
	validations: {
		customerTemp: {
			tanggal_lahir: {
				required
			}
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
		this.cloneVar()
	},
	watch: {
		customerTemp: {
			handler: function () {
				this.validate()
			},
			deep: true
		}
	},
	methods: {
		cloneVar() {
			this.customerTemp = JSON.parse(JSON.stringify(this.customer))
		},
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		validate() {
			this.pageSetting.btn.save.disabled = this.errorValidation()
		},
		errorValidation() {
			this.$v.customerTemp.tanggal_lahir.$touch()
			return this.$v.customerTemp.tanggal_lahir.$invalid
		},
		async update() {
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("customerModule/updateCustomerTanggalLahir", this.customerTemp)
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
			if (res.success) {
				this.$toast.success(res.msg)
				this.close()
			} else {
				this.$toast.error(res.err)
			}
		},
		getTanggalLahir(date) {
			this.customerTemp.tanggal_lahir = this.$moment(date).unix() * 1000
			this.customerTemp.tanggal_lahir_formated = this.$moment(date).format("DD MMM YYYY")
			this.customerTemp.tanggal_lahir_post = date
		}
	}
}
</script>